//data class PrimaryData (val s:String,val x:String,val y:String)
var OfferingsDTO = /** @class */ (function () {
    function OfferingsDTO(params) {
        this.description = params.description;
        this.rank = "";
        this.highlightIcon = params.url + params.highlightIcon;
        this.highlightText = params.highlightText;
        this.id = params._id;
        this.image = params.url + params.image;
        this.isNew = params.isNew;
        this.productRange = params.productRange;
        this.title = params.title;
        this.url = params.url;
    }
    return OfferingsDTO;
}());
export default OfferingsDTO;
